import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import store from './store/Store'
import { Provider } from 'react-redux'
import { setAxiosAuthToken } from './utils/AuthServices';
import { fetchTeacher, teacherAuthStateSwap } from './store/TeacherSlice';
import { fetchStudent, studentAuthStateSwap, fetchResults } from './store/StudentSlice';
import { fetchFrontPage } from './store/FrontPageSlice';


const authStatus = JSON.parse(localStorage.getItem('access_token'))
const currentTime = new Date()
const loginTime = JSON.parse(localStorage.getItem('login_time'))
const lastLogged = new Date(loginTime)

if (authStatus && (currentTime <= lastLogged)) {
    setAxiosAuthToken(authStatus)
    const authUser = localStorage.getItem('user_id') || ''
    const userType = localStorage.getItem('user_type') || ''
    if (userType && authUser) {
        store.dispatch(fetchFrontPage())
        if (userType === 'Teacher') {
            store.dispatch(fetchTeacher(parseInt(authUser)))
            store.dispatch(teacherAuthStateSwap(true))
        } else if (userType === 'Student') {
            store.dispatch(fetchStudent(parseInt(authUser)))
                .then(() => {
                    store.dispatch(fetchResults(parseInt(authUser)))
                })
            store.dispatch(studentAuthStateSwap(true))
        }
    }
} else {
    localStorage.clear()
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
